import { Building2, AlertTriangle, User, Target } from 'lucide-react'

type ScenarioData = {
  industry: string
  companyDescription: string
  companyChallenges: string
  participantRole: string
  participantObjectives: string
} | null

type ScenarioOverviewProps = {
  scenario: ScenarioData
}

export function ScenarioOverview({ scenario }: ScenarioOverviewProps) {
  if (!scenario) {
    return (
      <div className="text-center py-8 text-gray-500">
        No scenario defined for this simulation
      </div>
    )
  }

  const sections = [
    {
      icon: Building2,
      title: 'Industry',
      content: scenario.industry,
      color: 'text-blue-600 bg-blue-50',
    },
    {
      icon: Building2,
      title: 'Company Description',
      content: scenario.companyDescription,
      color: 'text-indigo-600 bg-indigo-50',
    },
    {
      icon: AlertTriangle,
      title: 'Company Challenges',
      content: scenario.companyChallenges,
      color: 'text-orange-600 bg-orange-50',
    },
    {
      icon: User,
      title: 'Participant Role',
      content: scenario.participantRole,
      color: 'text-purple-600 bg-purple-50',
    },
    {
      icon: Target,
      title: 'Participant Objectives',
      content: scenario.participantObjectives,
      color: 'text-green-600 bg-green-50',
    },
  ]

  return (
    <div className="p-4 space-y-4">
      {sections.map(({ icon: Icon, title, content, color }) => (
        <div
          key={title}
          className="bg-white border border-gray-200 rounded-lg overflow-hidden"
        >
          <div className={`px-4 py-3 border-b border-gray-100 ${color.split(' ')[1]}`}>
            <div className="flex items-center gap-2">
              <Icon className={`w-5 h-5 ${color.split(' ')[0]}`} />
              <h3 className="font-medium text-gray-900">{title}</h3>
            </div>
          </div>
          <div className="p-4">
            {content ? (
              <p className="text-sm text-gray-700 whitespace-pre-wrap">{content}</p>
            ) : (
              <p className="text-sm text-gray-400 italic">Not specified</p>
            )}
          </div>
        </div>
      ))}
    </div>
  )
}
